/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Popup from "vux/src/components/popup/index.vue"; // this line is trasformed by vux-loader
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import PopupPicker from "vux/src/components/popup-picker/index.vue"; // this line is trasformed by vux-loader
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import XButton from "vux/src/components/x-button/index.vue"; // this line is trasformed by vux-loader
import ScrollerList from '@/components/ScrollerList';
import ScrollerItem from '@/components/ScrollerList/ScrollerItem';
import SearchBar from '@/components/SearchBar';
import UserLogo from '@/components/UserLogo';
import { getServiceGroupList } from '@/api';
export default {
  components: {
    Popup: Popup,
    ViewBox: ViewBox,
    PopupPicker: PopupPicker,
    Group: Group,
    XButton: XButton,
    ScrollerList: ScrollerList,
    ScrollerItem: ScrollerItem,
    SearchBar: SearchBar,
    UserLogo: UserLogo
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    orderId: String,
    isSendRevised: Number
  },
  data: function data() {
    return {
      currValue: this.value,
      pageIndex: 0,
      pageSize: 10,
      keyword: '',
      groupId: -1,
      list: [],
      typeName: '',
      typeList: [{
        value: '',
        name: i18n.tc("67")
      }, {
        value: 1,
        name: i18n.tc("556")
      }, {
        value: 2,
        name: i18n.tc("557")
      }, {
        value: 3,
        name: i18n.tc("558")
      }],
      type: ''
    };
  },
  computed: {
    // 计算滚动区域高度
    scrollerHight: function scrollerHight() {
      var fontSize = window.getComputedStyle(window.document.documentElement)['font-size'];
      fontSize = Number(fontSize.substr(0, fontSize.length - 2));
      return document.documentElement.clientHeight - 4 * fontSize;
    }
  },
  watch: {
    value: function value(val) {
      this.currValue = val;
    },
    currValue: function currValue(val) {
      var _this = this;
      if (val) {
        this.$setLeft({
          control: true,
          onSuccess: function onSuccess() {
            _this.currValue = false;
          }
        });
      } else {
        this.$setLeft({
          control: false
        });
      }
      this.$emit('input', val);
    }
  },
  methods: {
    loadList: function loadList() {
      var _this2 = this;
      getServiceGroupList({
        pageIndex: this.pageIndex++,
        pageSize: this.pageSize,
        searchText: this.keyword,
        isSendRevised: this.isSendRevised,
        type: this.type
      }).then(function (res) {
        _this2.$refs['serviceGroupList'] && _this2.$refs['serviceGroupList'].donePullup();
        _this2.$refs['serviceGroupList'] && _this2.$refs['serviceGroupList'].donePulldown();
        if (res.success) {
          _this2.list = _this2.list.concat(res.data);
          if (res.data.length < _this2.pageSize) {
            _this2.$refs['serviceGroupList'] && _this2.$refs['serviceGroupList'].disablePullup();
          }
        } else {
          // 暂缺
        }
      });
    },
    resetList: function resetList() {
      this.list = [];
      this.pageIndex = 0;
      this.$refs['serviceGroupList'].enablePullup();
      this.loadList();
    },
    refresh: function refresh() {
      this.onPulldownLoading();
    },
    onPulldownLoading: function onPulldownLoading() {
      this.resetList();
    },
    onPullupLoading: function onPullupLoading() {
      this.loadList();
    },
    // onCheckOk (ids) {
    //   this.currValue = false
    //   let names = this.list.filter(item => ids.indexOf(item.id) !== -1).map(item => item.name)
    //   this.$emit('on-ok', ids, names)
    // },
    getTypeName: function getTypeName(type) {
      if (type === 1) return i18n.tc("556");
      if (type === 2) return i18n.tc("557");
      if (type === 3) return i18n.tc("558");
      return '';
    },
    // 选择团队
    onClick: function onClick(index) {
      var group = this.list[index];
      this.$emit('on-ok', group);
      this.currValue = false;
    }
  },
  created: function created() {
    this.loadList();
  }
};